import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/orders',
    name: 'POST_CUSTOMER_ORDER',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
